import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as KeysQL from "queries/key";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as tags from "@repoflow/form-schema/widgets/tag";
import { Button as ModalButton, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;


export const Content = ({
  match: {
    params
  },
}) => {
  const [phase, setPhase] = useState("init");
  const [secret, setSecret] = useState(null);
  // The keys list. replace(), not goBack(): the landing would otherwise depend
  // on how you reached the form, and after dismissing the secret modal you
  // could end up back on a page that no longer reflected the key just made.
  const { base } = useSectionContext();

  const initial = {
    description: "",
    roles: [],
  };
  return (
    <Mutation
      initial={initial}
      context={{
        phase, secret,
        setSecret,
        base
      }}
      target={{ $ref: "/Public/Key/Create" }}
      mutation={KeysQL.create}
      update={KeysQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        setPhase("loading");

        // An untouched description is the form's "" initial value, and sending
        // that would store an empty string where every key made before the
        // field existed — and every key auth's own forms make — has null. Two
        // representations of the same absence, in one column, for no reason.
        const { description, ...rest } = values;
        const trimmed = (description || "").trim();

        handler({
          variables: {
            input: trimmed ? { ...rest, description: trimmed } : rest,
          },
        });
      }}
      onCompleted={(data) => {
        const keySecret = data.viewer.account.keys.create.keySecret;
        setSecret(keySecret);
      }}
      onError={(error) => {
        // Without this the Create button keeps spinning, disabled, forever.
        setPhase("init");
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({
  schema,
  state,
  mutate,
  context: {
    phase,
    secret,
    setSecret,
    base
  },
  target,
}) => {
  const history = useHistory();
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: {
      "/Public/Key/Create": {
        fields: [
          "description",
          "roles"
        ],
      },
    },
    values,
    widgets: { tags }
  };

  const closeSecret = () => {
    setSecret(null)
    history.replace(base);
  }

  return (
    <CancellableContent>
      <Modal isOpen={secret !== null} toggle={closeSecret}>
        <ModalHeader toggle={closeSecret}>API Key Secret</ModalHeader>
        <ModalBody>
          Copy and save your API key secret: <br />
          <b>{secret}</b>
          <br />
          You are not going to see this secret again.
        </ModalBody>
        <ModalFooter>
          <ModalButton color="primary" onClick={closeSecret}>Close</ModalButton>
        </ModalFooter>
      </Modal>

      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit" loading={phase === "loading"}>
                Create
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
